<template>
  <span class="countdown" @click="pause()" :data-value="value < 0 ? 0 : value">
    <svg>
      <circle r="9" cx="10" cy="10" :class="`step-${value}`"></circle>
    </svg>
  </span>
</template>

<script>
export default {
  name: "CountdownCircle",
  data() {
    return {
      value: 6,
      intervalId: 0,
    };
  },
  inject: ["showNextDebate", "sidePanelVisible"],
  mounted() {
    setTimeout(() => (this.value = 5));
    this.init();
  },
  methods: {
    pause() {
      if (!this.intervalId) {
        this.count();
        this.init();
      } else {
        clearInterval(this.intervalId);
        this.intervalId = 0;
      }
    },
    init() {
      this.intervalId = setInterval(() => this.count(), 1000);
    },
    count() {
      if (!this.sidePanelVisible) {
        if (!--this.value) {
          this.showNextDebate();
        }
      }
    },
  },
};
</script>
